// src/pages/Gallery.jsx
import { useState } from "react";
import {
  Box,
  Typography,
  Container,
  Dialog,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "../styles/Gallery.css";
import { Helmet } from "react-helmet-async";

const galleryImages = [
  "/images/gallery/garden1.jpeg",
  "/images/gallery/garden2.jpeg",
  "/images/gallery/garden3.jpeg",
  "/images/gallery/garden4.jpg",
  "/images/gallery/garden5.jpg",
  "/images/gallery/garden6.jpeg",
  "/images/gallery/garden7.jpeg",
  "/images/gallery/garden8.jpeg",
  "/images/gallery/garden9.jpeg",
  "/images/gallery/garden10.jpeg",
  "/images/gallery/garden11.jpeg",
  "/images/gallery/garden12.jpeg",
  "/images/gallery/garden13.jpeg",
  "/images/gallery/garden14.jpeg",
  "/images/gallery/garden15.jpeg",
  "/images/gallery/garden16.jpeg",
  "/images/gallery/garden17.jpeg",
  "/images/gallery/garden18.jpeg",
  "/images/gallery/garden19.jpeg",
  "/images/gallery/garden20.jpeg",
  "/images/gallery/garden21.jpeg",
];

const Gallery = () => {
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleOpen = (img) => {
    setSelectedImage(img);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedImage(null);
  };

  return (
    <>
      <Helmet>
        <title>Gallery | KRM Landscape</title>
        <meta
          name="description"
          content="View the gallery of completed landscaping projects, gardens, plant setups, and green transformations by KRM Landscape."
        />
        <meta
          name="keywords"
          content="KRM Landscape, landscaping gallery, garden projects, plant setups, landscape transformations"
        />
      </Helmet>

      <Box className="gallery-page">
        <Container maxWidth="xl">
          {/* Page Heading */}
          <Box className="gallery-header">
            <Typography variant="h4" className="gallery-title">
              Our Gallery
            </Typography>

            <Typography className="gallery-subtitle">
              A glimpse of our landscape projects, plant setups, gardens, and
              green transformations crafted with care and creativity.
            </Typography>
          </Box>

          {/* Gallery Grid */}
          <Box className="gallery-grid">
            {galleryImages.map((img, index) => (
              <Box key={index} className="gallery-item">
                <img
                  src={img}
                  alt={`KRM Landscape Project ${index + 1}`}
                  onClick={() => handleOpen(img)}
                  style={{ cursor: "pointer" }}
                />
              </Box>
            ))}
          </Box>
        </Container>

        {/* Image Lightbox / Modal */}
        <Dialog
          open={open}
          onClose={handleClose}
          fullScreen
          PaperProps={{
            style: {
              backgroundColor: "rgba(0,0,0,0.9)",
            },
          }}
        >
          {/* Close Button */}
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 16,
              right: 16,
              color: "#fff",
              zIndex: 10,
            }}
          >
            <CloseIcon />
          </IconButton>

          <DialogContent
            sx={{
              width: "100vw",
              height: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              p: 0,
            }}
          >
            {selectedImage && (
              <img
                src={selectedImage}
                alt="KRM Landscape Full View"
                style={{
                  width: "90vw",
                  height: "90vh",
                  objectFit: "contain",
                  borderRadius: "12px",
                }}
              />
            )}
          </DialogContent>
        </Dialog>
      </Box>
    </>
  );
};

export default Gallery;
